import { redirectToLitlingoLogin } from 'actions';
import EpiqLogo from 'assets/epiq-logo.png';
import React from 'react';
import { useDispatch } from 'react-redux';

const SignInWithEpiqButton: React.FC = () => {
  const dispatch = useDispatch();

  const handleLoginClick = (): void => {
    dispatch(redirectToLitlingoLogin({ providerHint: 'epiq' }));
  };

  return (
    <button
      type="button"
      className="bg-litlingo-background flex gap-2 justify-center items-center border border-litlingo-line py-2 w-full focus:outline-none"
      onClick={handleLoginClick}
    >
      <img src={EpiqLogo} alt="epiq-logo" className="h-5 w-5" />
      <span className="text text--medium">
        Sign in with <b>Epiq</b>
      </span>
    </button>
  );
};

export default SignInWithEpiqButton;
